import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';


function IntroductionBlock(props) {


    const [addId] = useState(props.addId);
    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);
    const [text] = useState(props.text);
    const [eyeBrownHeader] = useState(props.eyeBrownHeader);
    const [withPadding] = useState(props.withPadding);
    const [subSectionClass, setSubSectionClass] = useState("howSubSectionMain");
    const [removeMargin] = useState(props.removeMargin);
    const [image] = useState(props.image);

    useEffect(() => {
        removePadding();
    
    
    }, [withPadding, subSectionClass]);

    function removePadding() {
        if (withPadding !== undefined && withPadding === false) {
            setSubSectionClass("howSubSectionMainWithoutTopPadding");
        }
    }

    

    return (

        <div className={"howSectionPosition " + (removeMargin ? "mt-0" : "")}>
            {eyeBrownHeader ?<div className="eyebrowHeader">
                {eyeBrownHeader}
            </div> : ""}
            {title ?<div id={addId} className="howLetterSection ">
                {title}
            </div> : ""}
            {subTitle ? 
                <div className="howLetterSection-sub centerFlex ">
                    {subTitle}
                </div>: ""}
            <div className={subSectionClass}>
                <div className="howSubSection">
                    {text}
                </div>
            </div>
            {image ?
                <div>
                    <img src={image} width={"100%"} />
                </div> : ""}
        </div>

    )


}

export default withRouter(IntroductionBlock);



